<template>
    <span
        class="icon"
        @click="$emit('click')"
    >
        <i :class="[ iconType ? iconType : 'fas' ,`fa-${icon}`]" />
    </span>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true,
        },
        iconType: {
            type: String,
            default: null,
        },
    },
};
</script>
